import { useAuthStore } from '@/stores'
import './ComingSoonPage.css'

export default function ComingSoonPage() {
  const { user, logout } = useAuthStore()

  const handleLogout = () => {
    localStorage.removeItem('branka_id_token')
    localStorage.removeItem('branka_access_token')
    localStorage.removeItem('branka_refresh_token')
    localStorage.removeItem('branka_user')
    logout()
    window.location.href = '/login'
  }

  return (
    <div className="coming-soon-page">
      <div className="coming-soon-container">
        <div className="coming-soon-header">
          <h1 className="coming-soon-logo">Branka</h1>
          <p className="coming-soon-tagline">Craft your ideas.</p>
        </div>

        <div className="coming-soon-content">
          <div className="coming-soon-icon">
            <svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" />
            </svg>
          </div>

          <h2 className="coming-soon-title">Coming Soon</h2>

          <p className="coming-soon-description">
            We're still preparing your garden. Branka is currently in private beta.
          </p>

          {user && (
            <p className="coming-soon-email">
              Signed in as <strong>{user.email}</strong>
            </p>
          )}

          <p className="coming-soon-notify">
            We'll notify you when your access is ready.
          </p>
        </div>

        <div className="coming-soon-footer">
          <button className="btn-logout" onClick={handleLogout}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  )
}
